import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ISagaCb } from '@typings/requestPayloads'

export interface IUpdateLanguagePayload extends ISagaCb {
    data: {
        language: string
    }
}

export interface IUpdateLanguageState {
    status: string
    data: any
    errors: any
}

const initialState: IUpdateLanguageState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const updateLanguage = createSlice({
    name: 'localization/update-language',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IUpdateLanguagePayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const updateLanguageActions = updateLanguage.actions
export default updateLanguage.reducer
